import React from 'react';
import Layout from './Layout/Layout';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Send } from 'lucide-react';

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for reaching out! We will get back to you shortly. 🙏");
  };

  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-b from-[#fffbf4] to-[#fff6e6] py-16 px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-amber-800 font-semibold text-xs tracking-[0.25em] uppercase mb-3 block">
            Get In Touch
          </span>
          <h2 className="text-3xl sm:text-5xl font-bold text-amber-950 mb-5 font-serif tracking-wide">
            Contact Us
          </h2>
          <div className="h-[2px] w-20 bg-amber-500 mx-auto mt-4"></div>
          <p className="text-stone-600 mt-4 max-w-xl mx-auto font-light text-sm md:text-base">
            Have questions or want to visit us? We would love to hear from you. Please fill out the form or use the contact details below.
          </p>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-stretch">
          {/* Map & Info Card */}
          <div className="lg:col-span-7 bg-white border border-amber-100 rounded-3xl shadow-md p-6 sm:p-8 flex flex-col justify-between">
            <div className="rounded-2xl overflow-hidden h-72 sm:h-96 relative shadow-inner mb-8">
              <iframe
                width="100%"
                height="100%"
                className="absolute inset-0"
                frameBorder="0"
                title="Google Map location of Jaipalpur"
                marginHeight={0}
                marginWidth={0}
                scrolling="yes"
                src="https://maps.google.com/maps?width=100%&height=600&hl=en&q=Jai%20Pal%20Pur,%20Uttar%20Pradesh%20222202&ie=UTF8&t=&z=14&iwloc=B&output=embed&ll=25.678644,82.1810659"
              ></iframe>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm md:text-base">
              <div>
                <h3 className="font-serif font-bold text-amber-950 text-base mb-3 flex items-center gap-2">
                  <MapPin size={18} className="text-amber-700" /> ADDRESS
                </h3>
                <p className="text-stone-500 font-light leading-relaxed">
                  Jaipalpur (Chaka), Mungra Badshahpur, <br />
                  Jaunpur PIN CODE - 222202, U.P.
                </p>
              </div>
              <div className="space-y-4">
                <div>
                  <h3 className="font-serif font-bold text-amber-950 text-base mb-2 flex items-center gap-2">
                    <Mail size={18} className="text-amber-700" /> EMAIL
                  </h3>
                  <p className="text-amber-700 hover:underline break-all">
                    <Link to="mailto:radhakrishnagramvikaskendra@gmail.com">
                      radhakrishnagramvikaskendra@gmail.com
                    </Link>
                  </p>
                </div>
                <div>
                  <h3 className="font-serif font-bold text-amber-950 text-base mb-2 flex items-center gap-2">
                    <Phone size={18} className="text-amber-700" /> PHONE
                  </h3>
                  <p className="text-stone-500 font-light">
                    <Link to="tel:+91-7042109297" className="hover:text-amber-700 transition">
                      +91-7042109297
                    </Link>
                    {", "}
                    <Link to="tel:+91-7525858518" className="hover:text-amber-700 transition">
                      +91-7525858518
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-5 bg-white border border-amber-100 rounded-3xl shadow-md p-6 sm:p-8 flex flex-col justify-between">
            <div>
              <h3 className="text-2xl font-serif font-bold text-amber-950 mb-2 leading-snug">
                Write To Us
              </h3>
              <p className="text-stone-500 text-sm font-light mb-8">
                Feel free to ask any questions or send feedback.
              </p>

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label htmlFor="name" className="block text-xs font-semibold text-stone-500 uppercase tracking-wider mb-2">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full bg-white rounded-xl border border-stone-200 focus:border-amber-500 focus:ring-4 focus:ring-amber-500/10 text-stone-800 py-3 px-4 outline-none transition-all duration-200"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-xs font-semibold text-stone-500 uppercase tracking-wider mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full bg-white rounded-xl border border-stone-200 focus:border-amber-500 focus:ring-4 focus:ring-amber-500/10 text-stone-800 py-3 px-4 outline-none transition-all duration-200"
                  />
                </div>

                <div>
                  <label htmlFor="contact" className="block text-xs font-semibold text-stone-500 uppercase tracking-wider mb-2">
                    Contact Number
                  </label>
                  <input
                    type="tel"
                    id="contact"
                    name="contact"
                    required
                    className="w-full bg-white rounded-xl border border-stone-200 focus:border-amber-500 focus:ring-4 focus:ring-amber-500/10 text-stone-800 py-3 px-4 outline-none transition-all duration-200"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-xs font-semibold text-stone-500 uppercase tracking-wider mb-2">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows="4"
                    className="w-full bg-white rounded-xl border border-stone-200 focus:border-amber-500 focus:ring-4 focus:ring-amber-500/10 text-stone-800 py-3 px-4 outline-none resize-none transition-all duration-200"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-700 hover:to-amber-800 text-white font-bold text-xs uppercase tracking-widest py-4 rounded-xl shadow-md hover:shadow-lg transition-all flex items-center justify-center gap-2"
                >
                  <Send size={14} /> Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Contact